// extracted by mini-css-extract-plugin
export default {"pageWrap":"AppLayout_pageWrap__cMEE7","switchDesktop":"AppLayout_switchDesktop__mZKfq","switchMobile":"AppLayout_switchMobile__96EKd"};